import { render, staticRenderFns } from "./ComparePlansModal.vue?vue&type=template&id=2a8170b4&"
import script from "./ComparePlansModal.vue?vue&type=script&lang=js&"
export * from "./ComparePlansModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports